module.exports = __webpack_public_path__ + "static/media/comecar-button.ffbaa5b7.png";